import { render, staticRenderFns } from "./ReturnsKit.vue?vue&type=template&id=362545e8&scoped=true"
import script from "./ReturnsKit.vue?vue&type=script&lang=js"
export * from "./ReturnsKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362545e8",
  null
  
)

export default component.exports